<template>
  <div>
    <d-card-header class="border-bottom flex-header">
      <h6 class="m-0">
        <template v-if="isContractAdd">
          Wybierz zabezpieczenia
        </template>
        <template v-else>
          Zabezpieczenia
        </template>
      </h6>
      <template v-if="isContractAdd">
        <d-button
          @click.prevent="addNewGuarantee"
          theme="primary">
          <i class="material-icons">add</i> Dodaj nowe zabezpieczenie
        </d-button>
      </template>
      <template v-if="!isContractAdd">
        <d-button
          :disabled="!canSendGuaranteesAgreement"
          theme="primary"
          @click.prevent="downloadGuaranteesAgreement"
          :class="{isLoading: actionInProgress}">
          <span style="white-space: nowrap;">
            <i class="material-icons">save_alt</i> Pobierz zgodę na zdjęcie zabezpieczeń
          </span>
        </d-button>
        <d-button
          v-if="!isDraft"
          @click.prevent="guaranteesEdit = !guaranteesEdit"
          theme="success">
          <i class="material-icons">edit</i> Edytuj
        </d-button>
        <d-button
          @click.prevent="addNewGuarantee"
          theme="primary">
          <i class="material-icons">add</i> Dodaj
        </d-button>
      </template>
    </d-card-header>
    <d-list-group-item>
      <table class="table mb-0 responsive-table" v-if="guarantees">
        <thead class="bg-light">
          <tr>
            <th v-if="guaranteesEdit" scope="col" class="border-0 id-cell" :style="`width: ${isContractAdd ? 51 : 85}px;`"></th>
            <th v-else scope="col" class="border-0 id-cell" style="width: 85px;">ID</th>
            <th scope="col" class="border-0">Rodzaj</th>
            <th scope="col" class="border-0">Numer księgi wieczystej</th>
            <th scope="col" class="border-0">Numer działki</th>
            <th scope="col" class="border-0">Wartość hipoteki</th>
            <th
              v-if="!isDraft && !isContractAdd"
              scope="col"
              class="border-0 text-center">
              Status
            </th>
            <th
              v-if="!isDraft && !isContractAdd"
              scope="col"
              class="border-0 text-center">
              Data statusu
            </th>
            <th scope="col" class="border-0 text-center" :style="actionsColStyle">Akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(guarantee, index) in scheduleGuarantees" :key="guarantee.id">
            <td>
              <dt></dt>
              <dd v-if="guaranteesEdit">
                <d-checkbox :value="guarantee.id" v-model="guaranteesSelected"></d-checkbox>
              </dd>
              <dd v-else>{{ guarantee.id}}</dd>
            </td>
            <td>
              <dt>Rodzaj</dt>
              <dd>{{ guarantee.type }}</dd>
            </td>
            <td>
              <dt>Numer księgi wieczystej</dt>
              <dd>{{ guarantee.number_land_mortgate_register || '-' }}</dd>
            </td>
            <td>
              <dt>Numer działki</dt>
              <dd>{{ guarantee.number_land || '-' }}</dd>
            </td>
            <td>
              <dt>Wartość hipoteki</dt>
              <dd>
                <!-- guarantee.mortgage_amount_mortgage -hipoteka -->
                 <!-- guarantee.mortgage_amount - wartośc nieruchomości -->
                <ss-price-input
                  :disabled="!guaranteesEdit"
                  type="text"
                  name="mortgage_amount"
                  v-model="guarantee.mortgage_amount_mortgage"/>
              </dd>
            </td>
            <td
              v-if="!isDraft && !isContractAdd"
              class="text-center">
              <dt>Status</dt>
              <dd v-if="getIsPaymentGuarantee(guarantee.id)">
                <span :class="getGuaranteeStatusClass(guarantee.status)">
                  {{ getGuaranteeStatusLabel(guarantee.status) }}
                </span>
              </dd>
              <dd v-else></dd>
            </td>
            <td
              v-if="!isDraft && !isContractAdd"
              class="text-center">
              <dt>Data statusu</dt>
              <dd v-if="getIsPaymentGuarantee(guarantee.id)">
                {{ guarantee.status_date || '-' }}
              </dd>
              <dd v-else></dd>
            </td>
            <td class="text-center">
              <dt>Akcje</dt>
              <dd>
                <template v-if="isContractAdd">
                  <d-button
                    @click.prevent="showGuarantee(guarantee)"
                    size="sm">
                    <i class="material-icons" style="top: 4px; left: -2px">visibility</i>
                  </d-button>
                  <d-button
                    @click.prevent="editGuarantee(guarantee)"
                    theme="success"
                    class="ml-3"
                    size="sm">
                  <i class="material-icons" style="top: 4px; left: -2px">edit</i>
                </d-button>
                </template>
                <template v-else>
                  <d-dropdown>
                    <template slot="button-content">
                      <i class="material-icons" style="margin-right: 0;">settings</i> Akcje
                    </template>
                    <d-dropdown-item class="px-0 py-0">
                      <button
                        class="dropdown-item"
                        title="Zobacz"
                        @click.prevent="showGuarantee(guarantee)">
                        <i class="material-icons">visibility</i><span>Zobacz</span>
                      </button>
                    </d-dropdown-item>
                    <d-dropdown-item class="px-0 py-0">
                      <button
                        class="dropdown-item"
                        title="Edytuj"
                        @click.prevent="editGuarantee(guarantee)">
                        <i class="material-icons">edit</i><span>Edytuj</span>
                      </button>
                    </d-dropdown-item>
                    <d-dropdown-item
                      class="px-0 py-0">
                      <button
                        class="dropdown-item"
                        title="Wpisane zobowiązania"
                        @click.prevent="showObligationsModal(guarantee)">
                        <i class="material-icons">format_list_bulleted</i><span>Wpisane zobowiązania</span>
                      </button>
                    </d-dropdown-item>
                    <d-dropdown-item
                      v-if="isDraft"
                      class="px-0 py-0">
                      <button
                        class="dropdown-item"
                        title="Usuń"
                        @click.prevent="removeGuarantee(guarantee)">
                        <i class="material-icons">delete</i><span>Usuń</span>
                      </button>
                    </d-dropdown-item>
                    <d-dropdown-item
                      v-if="getHasStatusChangeAction(guarantee.id)"
                      class="px-0 py-0">
                      <button
                        class="dropdown-item"
                        title="Zmień status"
                        @click.prevent="showStatusChangePopup(guarantee)">
                        <i class="material-icons">military_tech</i><span>Zmień status</span>
                      </button>
                    </d-dropdown-item>
                    <d-dropdown-item
                      v-if="getIsPaymentGuarantee(guarantee.id)"
                      class="px-0 py-0">
                      <button
                        class="dropdown-item"
                        title="Pobierz zgodę na zdjęcie zabezpieczenia"
                        @click.prevent="downloadGuaranteeAgreement(guarantee)">
                        <i class="material-icons">save_alt</i><span>Pobierz zgodę na<br>zdjęcie zabezpieczenia</span>
                      </button>
                    </d-dropdown-item>
                  </d-dropdown>
                </template>
              </dd>
            </td>
          </tr>
          <tr v-if="scheduleGuarantees.length < 1">
            <td
              :colspan="(!isDraft && !isContractAdd) ? 8 : 6"
              class="text-info text-center">
              Brak zabezpieczeń do wyświetlenia
            </td>
          </tr>
        </tbody>

      </table>
    </d-list-group-item>

    <guarantee-form-modal
      v-if="isGuaranteeModalVisible"
      :client-id="clientId"
      :guarantors="guarantors"
      :is-modal-visible="isGuaranteeModalVisible"
      :selected-guarantee="selectedGuarantee" />

    <guarantee-modal-readonly
      v-if="isReadonlyModalVisible"
      :show.sync="isReadonlyModalVisible"
      :props="selectedGuarantee"
      :guarantors="guarantors" />

    <guarantee-obligations-modal
      v-if="isObligationsModalVisible && obligationsGuarantee"
      :is-visible="isObligationsModalVisible"
      :guarantee="obligationsGuarantee"
      :client-id="clientId"
      @close="handleObligationsClose"
      @saved="handleObligationsSaved" />

    <guarantee-status-modal
      ref="guaranteeStatusModal"
      :schedule-id="schedule.id || 0" />
  </div>
</template>

<script>
import FileSaver from 'file-saver';
import GuaranteeUtils from '@/utils/guarantee.js';
import SsDate from '@/components/common/SsDate';
import SsPriceInput from '@/components/common/SsPriceInput';
import GuaranteeModalReadonly from '@/components/client/GuaranteeModalReadonly.vue';
import GuaranteeFormModal from '@/components/client/contract-partials/guarantees/GuaranteeFormModal.vue';
import GuaranteeStatusModal from '@/components/client/contract-partials/guarantees/GuaranteeStatusModal.vue';
import GuaranteeObligationsModal from '@/components/client/contract-partials/guarantees/GuaranteeObligationsModal.vue';

export default {
  name: 'ContractGuarantees',
  components: {
    SsDate,
    SsPriceInput,
    GuaranteeModalReadonly,
    GuaranteeFormModal,
    GuaranteeStatusModal,
    GuaranteeObligationsModal
  },
  props: {
    clientId: {
      required: true,
      type: Number
    },
    clientName: {
      default: '',
      type: String
    },
    guarantees: {
      default: () => [],
      type: Array
    },
    guaranteesDefault: {
      default: () => [],
      type: Array
    },
    guarantors: {
      default: () => [],
      type: Array
    },
    isContractAdd: {
      default: false,
      type: Boolean
    },
    isDraft: {
      required: true,
      type: Boolean
    },
    schedule: {
      required: true,
      type: Object
    }
  },
  computed: {
    canSendGuaranteesAgreement(){
      if (this.isContractAdd) {
        return false;
      }

      if (!this.scheduleGuarantees.length) {
        return false;
      }

      return true;
    },
    mergedGuarantees() {
      return this.guarantees.map(item => {
        if (this.isContractAdd) {
          item.mortgage_amount_mortgage = 0;
        } else {
          const isPaymentGuarantee = this.schedule.payment_guarantees.find(g => g.id === item.id);

          if (isPaymentGuarantee) {
            item.mortgage_amount_mortgage = isPaymentGuarantee.mortgage_amount || 0;
            item.status = isPaymentGuarantee.status;
            item.status_date = isPaymentGuarantee.status_date;
          }
        }

        return item
      })

    },
    scheduleGuarantees () {
      if (this.guaranteesEdit) {
        return this.mergedGuarantees;
      }
      return this.mergedGuarantees.filter((doc)=> this.guaranteesSelected.includes(doc.id));
    },
    selectedGuaranteesFormatted () {
      return this.mergedGuarantees.filter(guarantee => {
        return this.guaranteesSelected.includes(guarantee.id)
      }, []).map(guarantee => {
        return {
          id: guarantee.id,
          mortgage_amount: guarantee.mortgage_amount_mortgage || 0
        }
      });
    },
    statuses () {
      return GuaranteeUtils.getAvailableStatuses();
    },
    actionsColStyle () {
      if (this.isContractAdd) {
        return 'width: 124px;';
      }

      return 'width: 121px;';
    }
  },
  data () {
    return {
      actionInProgress: false,
      guaranteesEdit: false,
      guaranteesSelected: [],
      isGuaranteeModalVisible: false,
      isReadonlyModalVisible: false,
      selectedGuarantee: null,
      isObligationsModalVisible: false,
      obligationsGuarantee: null
    }
  },
  mounted () {
    this.$bus.$on('guarantee-form-modal-close', this.closeGuaranteeModal);
    if (this.isDraft || this.isContractAdd) {
      this.guaranteesEdit = true;
    }

    // Inicjalizuj guaranteesSelected z schedule.payment_guarantees
    if (this.schedule.payment_guarantees && Array.isArray(this.schedule.payment_guarantees)) {
      this.guaranteesSelected = this.schedule.payment_guarantees.map(g => {
        return typeof g === 'object' ? g.id : g;
      });
    }
  },
  methods: {
    closeGuaranteeModal (shouldReload = true) {
      this.isReadonlyModalVisible = false;
      this.isGuaranteeModalVisible = false;

      if (shouldReload) {
        if (this.isContractAdd) {
          this.$bus.$emit('client-reload-gurantees', false);
        } else {
          this.$bus.$emit('reload-contract');
          this.$bus.$emit('contract-reload-guarantees');
        }
      }
    },
    showGuarantee (guarantee) {
      this.selectedGuarantee = guarantee;
      this.isGuaranteeModalVisible = false;
      this.isReadonlyModalVisible = true;
    },
    addNewGuarantee () {
      const newGuarantee = _.clone(GuaranteeUtils.getDefaultGuaranteeObject());
      if (this.clientId) {
        newGuarantee.client_id = this.clientId;
      }
      Vue.set(this, 'selectedGuarantee', newGuarantee);

      this.$nextTick(() => {
        this.isGuaranteeModalVisible = true;
      })
    },
    editGuarantee (guarantee) {
      Vue.set(this, 'selectedGuarantee', JSON.parse(JSON.stringify(guarantee)));

      this.$nextTick(() => {
        this.isGuaranteeModalVisible = true;
      });
    },
    removeGuarantee (guarantee) {
      Vue.swal({
        title: 'Uwaga',
        html: 'Czy potwierdzasz usunięcie<br /><strong>' + guarantee.type + ' ' + guarantee.number_land_mortgate_register + '</strong><br />z listy zabezpieczeń?<br /><br /><span class="text-danger">Zabezpieczenie zostanie również usunięte z karty klienta.</span>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        buttonsStyling: true
      }).then((result) => {
      if (result.value) {
        axios.post('api/payment-guarantees/remove-payment-guarantee', {
          id: guarantee.id
        }).then(response => {
        if (response.data.cannot_delete && response.data.cannot_delete === 1) {
          Vue.swal({
            type: 'info',
            html: 'By usunąć zabezpieczenie <strong>' + guarantee.type + ' ' + guarantee.number_land_mortgate_register + '</strong>,<br /> odepnij je najpierw z&nbsp;umów w&nbsp;których uczestniczy',
            showConfirmButton: true,
          })
        } else {
          Vue.swal({
            type: 'success',
            title: 'Zabezpieczenie zostało usunięte.',
            showConfirmButton: true,
          }).then(() => {
            this.closeGuaranteeModal();
          });
        }
        }).catch((errors) => {
          console.log(errors);
        })
      }
      }).catch((errors) => {
        console.log(errors);
      })
    },
    downloadGuaranteeAgreement (guarantee) {
      this.actionInProgress = true;
      axios.post('api/payment-guarantees/remove-single-mortgage?date=' + Date.now(),
        {
          schedule_id: this.schedule.id,
          id: guarantee.id
        },
        { responseType: 'blob' }
      ).then(response => {
        let blob = new File([response.data],
          this.clientName + '_zgoda_na_zdjecie_zabezpieczenia.docx',
        );
        FileSaver.saveAs(blob);
        this.actionInProgress = false;
      }).catch((error) => {
        Vue.swal({
          title: 'Nie udało się pobrać pliku',
          text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
          type: 'error',
        });
        this.actionInProgress = false;
      });
    },
    downloadGuaranteesAgreement () {
      this.actionInProgress = true;

      axios.post('api/payment-guarantees/remove-mortgage?date=' + Date.now(),
        {
          schedule_id: this.schedule.id,
          id: this.guaranteesDefault[0]
        },
        { responseType: 'blob' }
      ).then(response => {
        let blob = new File([response.data],
          this.clientName + '_zgody_na_zdjecie_zabezpieczen.zip',
        );
        FileSaver.saveAs(blob);
        this.actionInProgress = false;
      }).catch((error) => {
        Vue.swal({
          title: 'Nie udało się pobrać pliku',
          text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
          type: 'error',
        });
        this.actionInProgress = false;
      });
    },
    getGuaranteeStatusClass (status) {
      let statusFound = this.statuses.find(item => item.value === status);

      if (!statusFound) {
        return '-'
      }

      return statusFound.class;
    },
    getGuaranteeStatusLabel (status) {
      let statusFound = this.statuses.find(item => item.value === status);

      if (!statusFound) {
        return '-'
      }

      return statusFound.label;
    },
    showStatusChangePopup (guarantee) {
      this.$refs.guaranteeStatusModal.showModal(guarantee);
    },
    showObligationsModal (guarantee) {
      this.obligationsGuarantee = JSON.parse(JSON.stringify(guarantee));
      this.isObligationsModalVisible = true;
    },
    handleObligationsClose (shouldReload = false) {
      this.isObligationsModalVisible = false;
      this.obligationsGuarantee = null;
      if (shouldReload) {
        this.$bus.$emit('reload-contract');
        this.$bus.$emit('contract-reload-guarantees');
      }
    },
    handleObligationsSaved () {
      this.$bus.$emit('reload-contract');
      this.$bus.$emit('contract-reload-guarantees');
    },
    getHasStatusChangeAction (guaranteeID) {
      if (this.isDraft || this.isContractAdd) {
        return false;
      }

      if (!this.schedule.payment_guarantees || !this.schedule.payment_guarantees.length) {
        return false;
      }

      return this.schedule.payment_guarantees.some(item => item.id === guaranteeID);
    },
    getIsPaymentGuarantee (guaranteeID) {
      if (!this.schedule.payment_guarantees || !this.schedule.payment_guarantees.length) {
        return false;
      }

      return this.schedule.payment_guarantees.some(item => item.id === guaranteeID);
    }
  },
  beforeDestroy () {
    this.$bus.$off('guarantee-form-modal-close', this.closeGuaranteeModal);
  }
}
</script>